import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Spinner, Button, Card } from "reactstrap"
import moment from "moment"
import { map } from "lodash"
import PropTypes from "prop-types"

// Actions
import { getLeadHistoryByLead } from "store/actions"

// Icons
import { FiClock, FiArrowRight, FiChevronDown } from "react-icons/fi"

function LeadHistory() {
  const dispatch = useDispatch()
  const params = useParams()

  const { AllLeadHistorys, loading } = useSelector(state => ({
    AllLeadHistorys: state.LeadHistory?.leadhistorysById,
    loading: state.LeadHistory?.loading,
  }))

  const [showAll, setShowAll] = useState(false)
  const [displayLimit, setDisplayLimit] = useState(5)

  useEffect(() => {
    dispatch(getLeadHistoryByLead(params?.id, 50))
  }, [dispatch, params?.id])

  // Get items to display based on showAll state
  const displayedItems = showAll
    ? AllLeadHistorys
    : AllLeadHistorys?.length && AllLeadHistorys?.slice(0, displayLimit)

  const hasMore = AllLeadHistorys?.length > displayLimit

  return (
    <div className="lead-history-timeline">
      {loading ? (
        <div className="d-flex justify-content-center py-4">
          <Spinner color="primary" size="sm" />
        </div>
      ) : (
        <Card className="p-3">
          <p className="h6 p-2 text-muted">Lead History</p>{" "}

          {AllLeadHistorys?.length >= 1 ? (
            <>
              {/* Timeline Container */}
              <div className="position-relative" style={{ paddingLeft: "40px" }}>
                {/* Vertical Dotted Line */}
                <div
                  style={{
                    position: "absolute",
                    left: "15px",
                    top: "10px",
                    bottom: "10px",
                    width: "2px",
                    borderLeft: "2px dashed #e0e0e0"
                  }}
                />

                {/* Timeline Items */}
                {map(displayedItems, (item, index) => (
                  <div
                    key={item?._id || index}
                    className="timeline-item d-flex align-items-start mb-3 position-relative"
                    style={{ minHeight: "50px" }}
                  >
                    {/* Clock Icon */}
                    <div
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        left: "-40px",
                        top: "0",
                        width: "30px",
                        height: "30px",
                        backgroundColor: "#fff",
                        border: "2px solid #e0e0e0",
                        borderRadius: "50%",
                        zIndex: 1
                      }}
                    >
                      <FiClock size={14} className="text-muted" />
                    </div>

                    {/* Date & Time */}
                    <div
                      className="date-section me-3 flex-shrink-0"
                      style={{ minWidth: "85px" }}
                    >
                      <span
                        className="fw-semibold text-dark"
                        style={{ fontSize: "14px" }}
                      >
                        {moment(item?.createdAt).format("DD MMM YYYY")}
                      </span>
                      <br />
                      <span
                        className="text-muted"
                        style={{ fontSize: "11px" }}
                      >
                        {moment(item?.createdAt).format("h:mm A")}
                      </span>
                    </div>

                    {/* Arrow */}
                    <div className="me-3 pt-1">
                      <FiArrowRight size={16} className="text-primary" />
                    </div>

                    {/* Activity Text */}
                    <div className="activity-text flex-grow-1 pt-1">
                      <p
                        className="m-0 text-dark"
                        style={{
                          fontSize: "13px",
                          lineHeight: "1.5"
                        }}
                      >
                        {item?.activity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* View More Button */}
              {hasMore && !showAll && (
                <div className="text-center mt-3">
                  <Button
                    color="primary"
                    size="sm"
                    className="px-4"
                    style={{ borderRadius: "20px" }}
                    onClick={() => setShowAll(true)}
                  >
                    View More <FiChevronDown className="ms-1" />
                  </Button>
                </div>
              )}

              {/* Show Less Button */}
              {showAll && hasMore && (
                <div className="text-center mt-3">
                  <Button
                    color="light"
                    size="sm"
                    className="px-4"
                    style={{ borderRadius: "20px" }}
                    onClick={() => setShowAll(false)}
                  >
                    Show Less
                  </Button>
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted m-0 font-size-13">No history available</p>
            </div>
          )}
        </Card>
      )}
    </div>
  )
}

export default LeadHistory

LeadHistory.propTypes = {
  leadDetails: PropTypes.obj,
}
